import React, { createContext, FC, ReactNode, useCallback, useContext, useEffect, useRef } from 'react';
import { useQueryParams } from '../hooks/useQueryParams';

export const ShowAllContext = createContext<{ ref?: React.RefObject<HTMLButtonElement> }>({});

export const ShowAllContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const ref = useRef<HTMLButtonElement>(null);

    return (
        <ShowAllContext.Provider value={{ ref }}>
            <ShowAllQueryParam />
            {children}
        </ShowAllContext.Provider>
    );
};

const ShowAllQueryParam = () => {
    const {
        showAll: { set: setShowAll }
    } = useQueryParams({ showAll: 'boolean' });

    const onShowAll = useCallback(() => setShowAll(true, true), [setShowAll]);
    useShowAll(onShowAll);

    return null;
};

export const useShowAll = (onShowAll: () => void) => {
    const { ref } = useContext(ShowAllContext);

    useEffect(() => {
        const element = ref?.current;

        element?.addEventListener('click', onShowAll);
        return () => {
            element?.removeEventListener('click', onShowAll);
        };
    }, [ref, onShowAll]);
};
